/**
 * UI copy for the Internal Materials flag (HE-F14).
 *
 * Field key stays `vendorMaterial` on the client row — a schema/API rename is
 * out of scope. Checking the box expands a notes row. Markup is applied later
 * from the task's material costing, not on this form.
 */
export const INTERNAL_MATERIALS_COLUMN = 'Int. Mat.';
export const INTERNAL_MATERIALS_ARIA = 'Internal materials';
export const INTERNAL_MATERIALS_TOOLTIP =
  'Materials from Dawson or Ministry stock, not vendor-supplied';
export const INTERNAL_MATERIALS_BADGE = 'Internal material';
export const INTERNAL_MATERIALS_NOTES_PLACEHOLDER = 'What material, and any notes? (please explain)';
/** TrueContext comments field — also becomes the material effort comment on approve. */
export const INTERNAL_MATERIALS_NOTES_FIELD = 'Comments 5';
